import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/[locale]/blog/que-deviennent-meubles-apres-debarras/PageClient.jsx");
